import template from './sicknessLeaveDate.html';
import controller from './sicknessLeaveDate.controller';
import './sicknessLeaveDate.scss';

let sicknessLeaveDateComponent = {
  restrict: 'E',
  bindings: {
    isRelapse : '<',
    isCreateSickness : '&',
    sicknessStartDate : '<',
    initLeaveDateKnown : '<',
    datepickLeaveDateKnown : '&',
    sicknessLeaveDateKnownReasons : '<',
    selectSicknessLeaveDateKnownReason : '&',
    setLeaveDateSendStatus: '&',
    minDate: '<',
    isMobileApp: '<',
  },
  template,
  controller
};

export default sicknessLeaveDateComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/sicknessLeaveDate/sicknessLeaveDate.component.js